import React from 'react';

import Image from './Image.jsx';
import Name from '../utility/Name.jsx';
import TypeConfig from '../utility/TypeConfig.jsx';

function LogoComponent(props) {
    let alt, defaultImage;
    if (props.data) {
        let data = props.data;
        if (data.Recipient) {
            data = data.Recipient;
        }
        alt = data.Company;
        if (data.Logo) {
            defaultImage = { extension: data.Logo.Extension, height: data.Logo.Height, id: data.Logo.S3Id || data.Logo.Id, width: data.Logo.Width };
        }
    }
    return <Image.Component {...props} alt={alt} defaultImage={defaultImage} image={defaultImage} />
}
const LogoTypeConfig = {
    panel: {
        block: function (defaultImage, alt) {
            return Image.TypeConfig.panel.block(defaultImage);
        },
        layout: function () {
            const group = 'layout';
            return {
                group,
                label: 'Layout',
                options: [
                    {
                        disabled: ['marginLeft', 'marginRight', 'marginBottom', 'marginTop'],
                        display: 'Padding/Margin',
                        group,
                        max: '300',
                        name: 'paddingMargin',
                        options: TypeConfig.options.measurement(),
                        type: 'paddingMargin',
                        value: {
                            paddingBottom: { value: '63', unit: 'px' },
                            paddingLeft: { value: '18', unit: 'px' },
                            paddingRight: { value: '18', unit: 'px' },
                            paddingTop: { value: '63', unit: 'px' }
                        }
                    }
                ]
            };
        }
    }
}
const LogoBlockTypeDefinition = (group, data, type = Name.Content.EmailBody) => {
    let alt, image, _data;
    if (data) {
        _data = data;
        if (_data.Recipient) {
            _data = _data.Recipient;
        }
        alt = _data.Company;
        if (_data.Logo) {
            image = { extension: _data.Logo.Extension, height: _data.Logo.Height, id: _data.Logo.Id || _data.Logo.S3Id, width: _data.Logo.Width };
        }
    }
    return {
        id: Name.Block.Logo,
        config: {
            block: LogoTypeConfig.panel.block({ alt, image }),
            layout: LogoTypeConfig.panel.layout()
        },
        display: type == Name.Content.EmailBody ? 'Logo' : 'Recipient Logo',
        group,
        image: 'logo.svg'
    };
}
const Logo = { BlockTypeDefinition: LogoBlockTypeDefinition, Component: LogoComponent, TypeConfig: LogoTypeConfig };

export default Logo;